module.exports = __webpack_public_path__ + "media/site/images/icons/code-icon-2cb9795f64cfbcd9e3f566cdf12d9562.svg";